import React from "react";
import Select from "react-select";

export const ExternalHashDropdown = ({
  externalHashList,
  handleHashChange,
  selectedVal,
}) => {
  const options = [];
  let selectedOption = null;

  if (externalHashList && externalHashList.length > 0) {
    externalHashList.forEach((hash) => {
      let hashObject = {};

      hashObject.value = hash.externalHashId;
      hashObject.label = hash.name;

      if (hash.utmMedium) {
        hashObject.utmMedium = hash.utmMedium;
        hashObject.utmSource = hash.utmSource;
        hashObject.utmCampaign = hash.utmCampaign;
      }

      options.push(hashObject);

      if (hash.externalHashId === selectedVal) {
        selectedOption = hashObject;
      }
    });
  }

  return (
    <div className="genericDropDown affiliateSelector">
      <Select
        defaultValue={options[0]}
        value={selectedOption}
        options={options}
        onChange={handleHashChange}
      />
    </div>
  );
};
